// Chạy `avatar sync` cho MỘT workspace bằng TIẾN TRÌNH CON (#211 phase-02).
//
// Vì sao fan-out tiến trình con thay vì gọi lại `syncAction` trong cùng tiến trình:
//   - `syncAction` bám `process.cwd()` và `process.exit()` ở 5 nhánh lỗi ⇒ gọi lặp trong
//     1 tiến trình là bất khả nếu không mổ lại 627 dòng đã có 8 e2e phủ (AC12);
//   - 1 workspace vỡ chỉ giết tiến trình con ⇒ vòng lặp đi tiếp (AC8);
//   - `process.exit()` của con trở thành exit code — đúng thứ cha cần đọc.
// Giá phải trả: N lần khởi động node. Chấp nhận được vì bộ lọc thường cắt N còn 0–2.
import { spawn } from "node:child_process";

export interface SpawnSyncOptions {
  /** Forward nguyên xuống con — người dùng gõ `--force` phải có tác dụng ở mọi workspace. */
  force?: boolean;
  packVersion?: string;
  local?: string;
}

export interface SpawnSyncResult {
  /** exit code của con; `null` khi con chết vì tín hiệu. */
  code: number | null;
  signal: NodeJS.Signals | null;
}

/**
 * Cờ forward xuống con. `--force` KHÔNG được nuốt: nuốt ⇒ `--all` im lặng skip mount dir
 * conflict ở N nơi, mà thông điệp "Dùng --force" lại nằm trong output của CON ⇒ người dùng
 * gõ đúng cờ vẫn không có tác dụng.
 */
export function buildChildSyncArgs(opts: SpawnSyncOptions): string[] {
  const args = ["sync"];
  if (opts.force === true) args.push("--force");
  if (opts.packVersion) args.push("--pack-version", opts.packVersion);
  if (opts.local) args.push("--local", opts.local);
  return args;
}

/**
 * Spawn `avatar sync` với `cwd` = workspace.
 *
 * `stdio: "inherit"` vì người dùng cần thấy tiến trình + prompt của từng nơi. Hệ quả phải
 * biết: con CÙNG PROCESS GROUP với cha ⇒ Ctrl-C bắn cả nhóm — đây chính là nguồn rủi ro
 * "`.claude/pack` biến mất giữa 2 lần rename của `atomicSwapDir`", và là lý do cha phải bắt
 * SIGINT/SIGTERM để in cảnh báo đích danh workspace đang dở.
 */
export function spawnSyncInWorkspace(
  workspaceRoot: string,
  opts: SpawnSyncOptions = {},
): Promise<SpawnSyncResult> {
  // `process.execPath` + `argv[1]` chạy đúng cả 2 đường: `node dist/index.js` (test/dev) và
  // bin script của npm global install. KHÔNG dùng tên lệnh `avatar` trên PATH — bản trên
  // PATH có thể là bản KHÁC với bản đang chạy (đúng cái phase-03 cần tránh khi re-exec).
  const child = spawn(process.execPath, [process.argv[1] ?? "", ...buildChildSyncArgs(opts)], {
    cwd: workspaceRoot,
    stdio: "inherit",
  });

  return new Promise<SpawnSyncResult>((resolve) => {
    // `error` (vd ENOENT khi entry CLI biến mất) không bao giờ kèm `close` ⇒ phải tự resolve,
    // nếu không vòng lặp `--all` treo vĩnh viễn ở workspace đó.
    child.once("error", () => resolve({ code: 1, signal: null }));
    child.once("close", (code, signal) => resolve({ code, signal }));
  });
}
